// src/client/components/LocaleSwitcher.tsx
//
// Phase B T2d: locale toggle (ja / en).
//  - 切替は i18next.changeLanguage(lng) の呼出のみ (永続化は Phase B+)
//  - aria-pressed で現在選択中の言語を支援技術へ伝達
//  - user.locale との同期は Phase B+ (T2d minimum scope の外)

import { useTranslation } from "react-i18next";
import { changeLocale, isSupportedLocale, SUPPORTED_LOCALES, type SupportedLocale } from "../lib/i18n";

const LABEL_KEYS: Record<SupportedLocale, string> = {
  ja: "locale.ja",
  en: "locale.en",
};

export function LocaleSwitcher(): JSX.Element {
  const { t, i18n } = useTranslation();
  const raw = i18n.resolvedLanguage ?? i18n.language;
  const current: SupportedLocale = isSupportedLocale(raw) ? raw : "ja";

  return (
    <div className="flex items-center gap-1 text-sm" role="group" aria-label={t("locale.label")}>
      {SUPPORTED_LOCALES.map((lng, idx) => {
        const active = current === lng;
        return (
          <span key={lng} className="flex items-center">
            <button
              type="button"
              onClick={() => {
                if (current !== lng) {
                  // en の文言は切替時に読み込む (lib/i18n.ts changeLocale)。 失敗時は今の言語のまま
                  changeLocale(lng).catch((err: unknown) => {
                    console.error("[LocaleSwitcher] failed to load locale", lng, err);
                  });
                }
              }}
              aria-pressed={active}
              className={
                active
                  ? "font-semibold text-foreground"
                  : "text-muted-foreground hover:text-foreground"
              }
            >
              {t(LABEL_KEYS[lng])}
            </button>
            {idx < SUPPORTED_LOCALES.length - 1 && (
              <span aria-hidden="true" className="mx-1 text-muted-foreground">
                /
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
